import { Controller } from "@hotwired/stimulus"

import Lenis from "lenis"

export default class extends Controller {
	connect() {
		if (this.isProductPage()) return

		this.lenis = new Lenis({
			duration: 1.2,
			easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
			orientation: 'vertical', // Vertical scroll for pages
			gestureOrientation: 'vertical',
			smoothWheel: true,
			wheelMultiplier: 1,      // Scroll speed multiplier
			touchMultiplier: 2,      // Touch scroll speed
			infinite: false,         // No infinite scroll (would break navigation)
			autoRaf: true
		})
	}

	isProductPage() {
		return document.body.classList.contains('product')
	}

	disconnect() {
		if (!this.lenis) return

		// Clean up on page leave
		this.lenis.destroy()
		cancelAnimationFrame(this.rafId)
	}
}
